import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_roen_5: FaireProductEntity = {
  token: "legacy_prod_roen-5",
  type: "product",
  name: "Nakame",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4199672d042d61e567171e4685da8d81277a7117a6643bb830c2b31fcdfd00b0.webp",
  priceDollars: 24,
  msrpDollars: 48,
  freeShipping: true,
  brandAvatarUrl: "/images/ROEN/Brand%20Page/roen-avatar.webp",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 4,
    depth: 2,
  },
  brandToken: "catalog_brand_roen",
  description: "Premium candle from ROEN.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["candles", "home fragrance", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
